import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import PublicLayout from "@/components/site/PublicLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Book from "@/pages/Book";
import Vendors from "@/pages/Vendors";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancelled from "@/pages/PaymentCancelled";
import PaymentFailed from "@/pages/PaymentFailed";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ScrollToHash from "@/components/site/ScrollToHash";

function AnimatedRoutes() {
    const location = useLocation();
    return (
        <AnimatePresence mode="wait" initial={false}>
            <Routes location={location} key={location.pathname}>
                <Route element={<PublicLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/services/:slug" element={<ServiceDetail />} />
                    <Route path="/task-partners" element={<Vendors />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/book" element={<Book />} />
                    {/* Legacy route redirects so deep links + bookmarks keep working */}
                    <Route path="/pricing" element={<Navigate to="/services#pricing" replace />} />
                    <Route path="/contact" element={<Navigate to="/about" replace />} />
                    <Route path="/vendors" element={<Navigate to="/task-partners" replace />} />
                    <Route path="/payment-success" element={<PaymentSuccess />} />
                    <Route path="/payment-cancelled" element={<PaymentCancelled />} />
                    <Route path="/payment-failed" element={<PaymentFailed />} />
                </Route>
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
        </AnimatePresence>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToHash />
                <AnimatedRoutes />
            </BrowserRouter>
            <Toaster richColors position="top-right" />
        </div>
    );
}

export default App;
